import axios from '../../../api/axios.js'
import {
    buryPointUrl
} from '../../../api/config.js'

// 首页推荐埋点
export const buryPointData = (payload) => {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    let areaInfo = localStorage.getItem('areaInfo') ? JSON.parse(localStorage.getItem('areaInfo')) : ''
    let data = {
        type: payload.type || 5,
        dfx_type: payload.dfx_type || 1,
        login_name: userInfo ? userInfo.phone : '',
        user_name: userInfo ? userInfo.name : '',
        user_id: userInfo ? userInfo.id : '',
        member_code: userInfo ? userInfo.companyCode : '',
        member_name: userInfo ? userInfo.companyName : '',
        merchant_code: userInfo ? userInfo.belongMerchantCode : '',
        merchant_name: userInfo ? userInfo.belongMerchantName : '',
        area: areaInfo.cityName,
        source: 1,
        ...payload
    }
    return axios.post(buryPointUrl + '/ets/api/event-tracks', data)
}